import { Box, TextField } from '@mui/material';
import { GRAY } from 'constants/colors';

const DisabledTextField = ({
  label,
  value,
  fullWidth = false,
  gridColumn = ''
}) => {
  return (
    <Box
      display="flex"
      gap={2.5}
      sx={{
        gridColumn
      }}
    >
      <TextField
        variant="outlined"
        label={label}
        value={value}
        disabled={true}
        className="read_mode"
        sx={{
          minWidth: fullWidth ? '100%' : 'initial'
        }}
        InputLabelProps={{
          sx: {
            paddingTop: '15px'
          },
          style: {
            WebkitTextFillColor: GRAY
          }
        }}
      />
    </Box>
  );
};

export default DisabledTextField;
